import http from './http';

type details = { goodsPrice?: number; saleCount?: number; skuCode?: string };

interface IPreOrder {
  details: details[];
  orderNo?: string | null;
  recNo: string;
  resvNo: string;
  roomId: number;
  roomNo: string;
  saleType: 0 | 1;
}

// 前台直售-门店仓库扣除查询
export const getStoreStorageSetting = () => {
  return http({
    url: `/goods/storage/storageSetting`,
    method: 'GET',
  });
};

// 获取商品列表 type -  饮品1 食品2 商品3 全部''
export const fetchGoodsList = (data?: { goodsName?: string; type?: 1 | 2 | 3 }) => {
  return http({
    url: '/goods/storage/reception',
    method: 'POST',
    data,
  });
};

// 获取查房列表
export const fetchCheckInClients = () => {
  return http({
    url: '/orders/check-in/rooms',
    method: 'GET',
  });
};

// 预下单
export const preOrder = (data: IPreOrder) => {
  return http({
    url: '/goods/order',
    method: 'POST',
    data,
  });
};

// 订单查询
export const getOrderDetail = (orderNo: string) => {
  return http({
    url: `/goods/order/${orderNo}`,
    method: 'GET',
  });
};

// 订单改价
export const orderChangePrice = (data: { orderNo: string; totalActualPrice: number }) => {
  return http({
    url: '/goods/order/change/price',
    method: 'POST',
    data,
  });
};

// 前台入账房间不支付
export const orderBillNotPay = (data) => {
  return http({
    url: '/goods/order/bill',
    method: 'POST',
    data,
  });
};

// 前台支付入账
export const orderBillPay = (data: {
  orderNo: string;
  payPrice: number;
  payType?: number;
  remark?: string;
  fkdFlag: boolean;
}) => {
  return http({
    url: '/goods/order/pay/bill',
    method: 'POST',
    data,
  });
};
